import React from "react";
import { Reveal, Eyebrow } from "./MarketingUI";
import { Building2, SlidersHorizontal, MapPin, Boxes } from "lucide-react";

const items = [
  { icon: Building2, title: "Dedicated Environment", desc: "Customer deployments are independently configured." },
  { icon: SlidersHorizontal, title: "Organization Configuration", desc: "Adapt users, roles, workflow and reporting to organizational needs." },
  { icon: MapPin, title: "Jurisdiction-Aware Data", desc: "Connect GovFlowState to the legislative sources relevant to the deployment." },
  { icon: Boxes, title: "GovFlowState Platform", desc: "Maintain a consistent, supported product foundation." },
];

export default function OrgDeployment() {
  return (
    <section className="bg-brand-civic-50 py-24 sm:py-28" data-testid="org-deployment-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Deployment model</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
              Built around your organization.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-brand-slate">
              GovFlowState can be configured around an organization&apos;s legislative workflow, users, roles, data sources and reporting needs — while preserving the GovFlowState platform experience.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={0.06 * i}>
              <div className="flex h-full flex-col rounded-2xl border border-brand-line bg-white p-6 shadow-card" data-testid={`org-deployment-${i}`}>
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-teal-50">
                  <it.icon className="h-5 w-5 text-brand-teal" strokeWidth={1.9} />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-brand-ink">{it.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-brand-slate">{it.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
